var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpinner = function SvgIconSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconSpinner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 1v2a1 1 0 0 1-2 0V1a1 1 0 0 1 2 0m-1 19a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m-8-8a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1m19-1h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2m-4.982-9.382a1 1 0 0 0-1.367.364l-1 1.731a1 1 0 0 0 1.731 1.001l1-1.731a1 1 0 0 0-.364-1.365M7.987 18.921a1 1 0 0 0-1.366.364l-1 1.731a1 1 0 1 0 1.731 1.001l1-1.731a1 1 0 0 0-.365-1.365m-3.272-12.3-1.731-1a1 1 0 0 0-1 1.731l1.731 1a1 1 0 0 0 1-1.731m17.3 10.03-1.731-1a1 1 0 0 0-1 1.731l1.731 1a1 1 0 1 0 1-1.731M7.349 1.982a1 1 0 0 0-1.731 1l1 1.731a1 1 0 1 0 1.731-1.001zm10.03 17.3a1 1 0 0 0-1.731 1l1 1.731a1 1 0 0 0 1.731-1zm2.408-10.8a1 1 0 0 0 .5-.134l1.731-1a1 1 0 0 0-1-1.731l-1.731 1a1 1 0 0 0 .5 1.865M3.713 15.648l-1.731 1a1 1 0 1 0 1 1.731l1.731-1a1 1 0 0 0-1-1.731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconSpinner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSpinner;